import autoBind from 'react-autobind'
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Content from '../components/Content.js'
import './CarWithPopups.css'

class CarWithPopups extends React.Component {
   constructor(props) {
    super(props);
    this.state = {
      plus1:false,
      plus11:"",
      plus2:false,
      plus22:"",
      plus3:false,
      plus33:"",
      plus4:false,
      plus44:"",
      plus5:false,
      plus55:"",
      plus6:false,
      plus66:"",
      plus7:false,
      plus77:"",
      plus8:false,
      plus88:"",
      plus9:false,
      plus99:"",
    };
    autoBind(this);
  }

  handlePlus1(){
    if(this.state.plus11 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus1: true});
      setTimeout(() => {
        this.setState({plus11: 
          <div>
            <div onClick={this.handlePlus11} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.aerodynamicsT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.aerodynamicsX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus11(){
    this.setState({plus11: "",plus1: false});
  }

  handlePlus2(){
    if(this.state.plus22 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus2: true});
      setTimeout(() => {
        this.setState({plus22: 
          <div>
            <div onClick={this.handlePlus22} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.transmissionT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.transmissionX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus22(){
    this.setState({plus22: "",plus2: false});
  }

  handlePlus3(){
    if(this.state.plus33 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus3: true});
      setTimeout(() => {
        this.setState({plus33: 
          <div>
            <div onClick={this.handlePlus33} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.bodyworkT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.bodyworkX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus33(){
    this.setState({plus33: "",plus3: false});
  }

  handlePlus4(){
    if(this.state.plus44 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus4: true});
      setTimeout(() => {
        this.setState({plus44: 
          <div>
            <div onClick={this.handlePlus44} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.combustionT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.combustionX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus44(){
    this.setState({plus44: "",plus4: false});
  }

  handlePlus5(){
    if(this.state.plus55 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus5: true});
      setTimeout(() => {
        this.setState({plus55: 
          <div>
            <div onClick={this.handlePlus55} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.wheelsT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.wheelsX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus55(){
    this.setState({plus55: "",plus5: false});
  }

  handlePlus6(){
    if(this.state.plus66 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus6: true});
      setTimeout(() => {
        this.setState({plus66: 
          <div>
            <div onClick={this.handlePlus66} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.chassisT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.chassisX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus66(){
    this.setState({plus66: "",plus6: false});
  }

  handlePlus7(){
    if(this.state.plus77 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus7: true});
      setTimeout(() => {
        this.setState({plus77: 
          <div>
            <div onClick={this.handlePlus77} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.brakesT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.brakesX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus77(){
    this.setState({plus77: "",plus7: false});
  }

  handlePlus8(){
    if(this.state.plus88 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus8: true});
      setTimeout(() => {
        this.setState({plus88: 
          <div>
            <div onClick={this.handlePlus88} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.electricT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.electricX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus88(){
    this.setState({plus88: "",plus8: false});
  }

  handlePlus9(){
    if(this.state.plus99 === ""){
      this.handlePlus11();
      this.handlePlus22();
      this.handlePlus33();
      this.handlePlus44();
      this.handlePlus55();
      this.handlePlus66();
      this.handlePlus77();
      this.handlePlus88();
      this.handlePlus99();
      this.setState({plus9: true});
      setTimeout(() => {
        this.setState({plus99: 
          <div>
            <div onClick={this.handlePlus99} className="carWithPopupHeaderWrapper">
            <div className="carWithPopupHeaderText"> 
              <Content source={this.props.page.dimensionsT} />
            </div>
            <img alt="close" src="../assets/icons/close.png" className="carWithPopupHeaderImg" />
            </div>
            <div className={"contentInPoupBox carWithPopupText"}>
              <Content source={this.props.page.dimensionsX} />
            </div>
          </div>});
        },300);
      }
  }
  handlePlus99(){
    this.setState({plus99: "",plus9: false});
  }

  

  fillDiv1(){
      var maxWidth  = document.getElementById('outer').clientWidth;
      var maxHeight = document.getElementById('outer').clientHeight;
      var width = window.innerWidth;
      var scale;
      if(window.innerWidth<=340){
        scale = (width - 20)/maxWidth;
      } else if(window.innerWidth>340 && window.innerWidth<=490){
        scale = (width - 40)/maxWidth;
      } else if(window.innerWidth>490 && window.innerWidth<=1250){
        scale = (width - 60)/maxWidth;
      } else {
        scale = 1.85;
      }
      document.getElementById('outer').style.transform = "translate(" + (((maxWidth * scale)-640)/2) + "px," + (((maxHeight * scale)-196)/2) +"px) scale(" + scale + "," + scale +")";

      document.getElementById('wrap').style.width = maxWidth * scale + "px";
      document.getElementById('wrap').style.height = (maxHeight * scale) + "px";
  }

  

  componentDidMount(){
    window.addEventListener('resize', this.fillDiv1, false);

    setTimeout(() => {
      this.fillDiv1();
    }, 100);
  } 
  componentWillUnmount(){
    window.removeEventListener('resize', this.fillDiv1, false);
  } 

  render() {
    const plus1State = this.state.plus1 ? "carWithPopupWrapper" : "carWithPlus";
    const plus2State = this.state.plus2 ? "carWithPopupWrapper" : "carWithPlus";
    const plus3State = this.state.plus3 ? "carWithPopupWrapper" : "carWithPlus";
    const plus4State = this.state.plus4 ? "carWithPopupWrapper" : "carWithPlus";
    const plus5State = this.state.plus5 ? "carWithPopupWrapper" : "carWithPlus";
    const plus6State = this.state.plus6 ? "carWithPopupWrapper" : "carWithPlus";
    const plus7State = this.state.plus7 ? "carWithPopupWrapper" : "carWithPlus";
    const plus8State = this.state.plus8 ? "carWithPopupWrapper" : "carWithPlus";
    const plus9State = this.state.plus9 ? "carWithPopupWrapper" : "carWithPlus";

    return (
        <div className="carWithWrapper">
          <div id="wrap" className="carWithWrap">
            <div id="outer" className="carWithOuter">
              <img alt="car" className="carWithOuter" src="../assets/pictures/car.png" />
              <img style={{display:"none"}} src="/assets/icons/plus.png" />
              <div className="carWithTextWrapperAbsolute">
                <div onClick={this.handlePlus1} className={plus1State+" carWithPlus1"}>
                  {this.state.plus11}
                </div>
                <div onClick={this.handlePlus2} className={plus2State+" carWithPlus2"}>
                  {this.state.plus22}
                </div>
                <div onClick={this.handlePlus3} className={plus3State+" carWithPlus3"}>
                  {this.state.plus33}
                </div>
                <div onClick={this.handlePlus4} className={plus4State+" carWithPlus4"}>
                  {this.state.plus44}
                </div>
                <div onClick={this.handlePlus5} className={plus5State+" carWithPlus5"}>
                  {this.state.plus55}
                </div>
                <div onClick={this.handlePlus6} className={plus6State+" carWithPlus6"}>
                  {this.state.plus66}
                </div>
                <div onClick={this.handlePlus7} className={plus7State+" carWithPlus7"}>
                  {this.state.plus77}
                </div>
                <div onClick={this.handlePlus8} className={plus8State+" carWithPlus8"}>
                  {this.state.plus88}
                </div>
                <div onClick={this.handlePlus9} className={plus9State+" carWithPlus9"}>
                  {this.state.plus99}
                </div>
               
              </div>
            </div>
          </div>

    

        </div>
    );
  }
}
const styles = StyleSheet.create({
  wrapper:{
    margin:"120px auto",
    textAlign:"center",
    position: "relative",
    marginTop:"200px",
  },


  wrap: {
    position: "relative",
    width: 640,

    marginBottom:30,
    marginLeft:30,
    '@media (max-width: 490px)': {
      marginLeft:20,
    },
    '@media (max-width: 340px)': {
      marginLeft:10,
    },
    '@media (min-width: 1250px)': {
      marginLeft:"calc((100% - 1190px)/2)",
    }
  },
  outer: {
    width:640,
    height: 196,
    position: "relative",
    objectFit:"cover",
  },

  textWrapperAbsolute:{
    position:"absolute",
    top:0,
    width:"100%",

    zIndex:100,
    // '@media (max-width: 715px)': {
    //   width:200,
    //   height:120,
    //   right:"4%",
    //   top:"32%",
    // }, 
    // '@media (max-width: 600px)': {
    //   width:220,
    //   right:"5%",
    //   top:"30%",
    // },
    // '@media (max-width: 500px)': {
    //   width:270,
    //   right:"2%",
    //   top:"26%",
    // },

  },

  contenetOnPicture1:{
    fontSize:14,
    fontWeight:600,
    color:"#fff",
    '@media (max-width: 715px)': {
      fontSize:20,
    }, 
    '@media (max-width: 600px)': {
      fontSize:24,
    }, 
    '@media (max-width: 500px)': {
      fontSize:30,
    },
  },
  contenetOnPicture2:{
    fontSize:10,
    fontWeight:500,
    color:"#fff",
    '@media (max-width: 715px)': {
      fontSize:14,
    }, 
    '@media (max-width: 600px)': {
      fontSize:17,
    }, 
    '@media (max-width: 500px)': {
      fontSize:22,
    },
  },
  contenetOnPicture3:{
    fontSize:10,
    marginTop:14,
    fontWeight:500,
    color:"#fff",
    '@media (max-width: 715px)': {
      fontSize:14,
    }, 
    '@media (max-width: 600px)': {
      fontSize:17,
    },
    '@media (max-width: 500px)': {
      fontSize:22,
    },
  },
  contenetOnPicture4:{
    fontSize:10,
    marginTop:5,
    fontWeight:500,
    color:"#fff",
    '@media (max-width: 715px)': {
      fontSize:14,
    }, 
    '@media (max-width: 600px)': {
      fontSize:17,
    },
    '@media (max-width: 500px)': {
      fontSize:22,
    },
  },
  plus:{
    backgroundImage:"url(../assets/icons/plus.png)",
    backgroundSize:"cover",
    borderRadius:"50%",
    transition:"0.32s",
    cursor:"pointer",
    zIndex:1000,

    position:"absolute",
    
    width:20,
    height:20,
    boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
    ":hover":{
      boxShadow: "0 4px 6px rgba(0,0,0,0.5)",
    }
  },
  plus1:{
    top:40,
    left:40,
  },
  plus2:{
    top:75,
    left:80,
  },
  plus3:{
    top:88,
    left:"30%",
  },
  plus4:{
    top:30,
    left:145,
  },
  plus5:{
    top:165,
    left:345,
  },
  plus6:{
    top:143,
    left:110,
  },
  plus7:{
    top:130,
    left:305,
  },
  plus8:{
    top:100,
    left:550,
  },
  plus9:{
    top:15,
    left:520,
  },


  popupWrapper:{
    width:240,
    top:-10,
    left:"calc((100% - 240px)/2)",
    borderRadius:20,
    height:200,
    transition:"0.5s",
    position:"absolute",
    boxShadow: "0 4px 8px rgba(0,0,0,0.6)",
    zIndex:10000,
    background:"#FBBC01",
    '@media (max-width: 920px)': {
      transform:"translate(0px, -30px) scale(1.2)",
    },
    '@media (max-width: 780px)': {
      transform:"translate(0px, -30px) scale(1.4)",
    },
    '@media (max-width: 650px)': {
      transform:"translate(0px, -30px) scale(1.6)",
    },
    '@media (max-width: 530px)': {
      transform:"translate(0px, -30px) scale(1.8)",
    },
    '@media (max-width: 440px)': {
      transform:"translate(0px, -30px) scale(2)",
    },
    '@media (max-width: 410px)': {
      transform:"translate(0px, -30px) scale(2.4)",
    },
  },
  popupHeaderWrapper:{
    width:"100%",
    height:40,
    display:"flex",
    background:"#FBBC01",
    alignItems:"center",
    paddingLeft:20,
    paddingRight:20,
    position:"relative",
    borderRadius:20,
    justifyContent:"space-between",
  },
  popupHeaderText:{
    color:"#000",
    fontWeight:600,
    fontSize:10,
    marginTop:10,
  },
  popupHeaderImg:{
    width:13,
    cursor:"pointer",
  },
  popupText:{
    position:"relative",
    overflowY: "auto",
    color:"#000",
    fontSize:8,
    height:145,
    fontWeight:500,
    textAlign:"left",
    padding:20,
    paddingTop:10,
  }
});




export default CarWithPopups;



// WEBPACK FOOTER //
// ./src/components/CarWithPopups.js